import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const ADMIN_TAB_PAGES: Readonly<Record<string, string>> = {
  users: '/admin/benutzer',
  meine_beitraege: '/admin/beitraege',
  verein_followers: '/admin/follower',
  verzeichnis: '/admin/verzeichnis',
};

export const adminLegacyTabGuard: CanActivateFn = (route) => {
  const page = ADMIN_TAB_PAGES[route.queryParamMap.get('tab') ?? ''];
  return page ? inject(Router).parseUrl(page) : true;
};
